import { render, staticRenderFns } from "./ManuallyItems.vue?vue&type=template&id=b4508876"
import script from "./ManuallyItems.vue?vue&type=script&lang=js"
export * from "./ManuallyItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports